<template>
  <div class="workorderHistoryContainerData">
    <div class="col-12 row text-center mx-0 table-responsive" style="">
      <b-table
        :items="workorderHistoryContainerDataItem"
        :fields="workorderHistoryContainerDataFields"
        sticky-header="480px"
        :no-border-collapse="true"
        @row-clicked="onRowClicked"
        class="workorderHistoryContainerData-table-detail table-row-click"
      >
        <template #cell(total_plno)="data">
          <div>
            {{ data.value.toLocaleString("en-US") }}
          </div>
        </template>
        <template #cell(total_weight)="data">
          <div>
            {{ data.value.toLocaleString("en-US") }}
          </div>
        </template>
      </b-table>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "workorderHistoryContainerData",
  data() {
    return {};
  },
  computed: {
    ...mapGetters({
      workorderHistoryContainerDataFields:
        "workorderHistoryContainerData/get_workorderHistoryContainerDataFields",
      workorderHistoryContainerDataItem:
        "workorderHistoryContainerData/get_workorderHistoryContainerDataItem",
      workorderHistoryTableStyle:
        "workorderHistoryContainerData/get_workorderHistoryTableStyle",
    }),
  },
  methods: {
    ...mapActions({
      axiosAction: "commonaxios/axiosAction",
      set_rowClickData: "workorderHistoryData/set_rowClickData",
    }),
    onRowClicked(items, index, event) {
      let vm = this;
      let obj = {
        items: items,
        index: index,
        event: event,
      };
      vm.set_rowClickData(obj);
    },
  },
};
</script>

<style>
</style>
<style lang="scss">
.workorderHistoryContainerData-table-detail > table > thead > tr > th {
  z-index: 1 !important;
}
.workorderHistoryContainerData-table-detail th,
.workorderHistoryContainerData-table-detail td {
  height: 2.5rem;
  min-width: 65px;
  padding: 0.45rem;
  border-color: #999999 !important;
  border-right: 1px solid;
  border-bottom: 1px solid #999999 !important;
  font-size: 1.125rem;
  font-weight: normal;
  vertical-align: middle !important;
}
.workorderHistoryContainerData-table-detail td {
  font-size: 1rem;
}
.workorderHistoryContainerData-table-detail.table-row-click td {
  cursor: pointer;
}
.workorderHistoryContainerData-table-detail th:first-child,
.workorderHistoryContainerData-table-detail td:first-child {
  border-left: 1px solid;
}
.workorderHistoryContainerData-table-detail tr th:nth-child(1),
.workorderHistoryContainerData-table-detail tr td:nth-child(1) {
  width: 150px;
  min-width: 150px;
}
.workorderHistoryContainerData-table-detail tr th:nth-child(2),
.workorderHistoryContainerData-table-detail tr td:nth-child(2) {
  width: 260px;
  min-width: 260px;
}
.workorderHistoryContainerData-table-detail tr th:nth-child(3),
.workorderHistoryContainerData-table-detail tr td:nth-child(3) {
  width: 260px;
  min-width: 260px;
}
.workorderHistoryContainerData-table-detail tr th:nth-child(4),
.workorderHistoryContainerData-table-detail tr td:nth-child(4) {
  width: 150px;
  min-width: 150px;
}
.workorderHistoryContainerData-table-detail tr th:nth-child(5),
.workorderHistoryContainerData-table-detail tr td:nth-child(5) {
  width: 120px;
  min-width: 120px;
}
.workorderHistoryContainerData-table-detail tr th:nth-child(6),
.workorderHistoryContainerData-table-detail tr td:nth-child(6) {
  width: 120px;
  min-width: 120px;
}
.workorderHistoryContainerData-table-detail tr th:nth-child(7),
.workorderHistoryContainerData-table-detail tr td:nth-child(7) {
  width: 120px;
  min-width: 120px;
}
.workorderHistoryContainerData-table-detail thead th {
  color: #ffffff !important;
  background-color: #4b8c80 !important;
}
.workorderHistoryContainerData-table-detail tr:nth-child(odd) {
  background-color: #ffffff;
}
.workorderHistoryContainerData-table-detail tr:nth-child(even) {
  background-color: rgba(75, 140, 128, 0.2);
}
</style>


// WEBPACK FOOTER //
// src/components/workorderHistoryContainerData.vue